<template>
  <!-- <section class="main_section" :style="{width: screenWidth+'px',height:screenHeight+'px'}"> -->
  <section class="main_section">
    <div class="headerBox">
      <!-- <keep-alive>  加上这条，和headerTop中的before-close冲突-->
      <header-top :navShow="true"></header-top>
      <!-- </keep-alive> -->
    </div>
    <el-main :style="{ width: screenWidth + 'px' }">
      <transition name="fade" mode="out-in">
        <!--需要缓存的页面-->
        <keep-alive>
          <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
      </transition>
      <transition name="fade" mode="out-in">
        <!--不需要缓存的页面-->
        <router-view v-if="!$route.meta.keepAlive"></router-view>
      </transition>
    </el-main>
    <el-footer style="height: 276px; margin: auto; padding: 0; background: #c0cbd9">
      <footer-btn></footer-btn>
    </el-footer>
  </section>
</template>

<script>
import headerTop from "@/components/headerTop";
import footerBtn from "@/components/footerBtn";

export default {
  name: "Main",
  components: {
    headerTop,
    footerBtn,
  },
  data() {
    return {
      screenWidth: 1200, // 屏幕尺寸
      screenHeight: document.body.clientHeight, // 屏幕尺寸
      show: false,
    };
  },
  methods: {},
  created() {},
  mounted() {
    // 挂在完成，也就是模板中的HTML渲染到HTML页面中，mounted只会执行一次。
    // const that = this
    // window.onresize = () => {
    //     return (() => {
    //         that.screenWidth = document.body.clientWidth;
    //         that.screenHeight = document.body.screenHeight;
    //     })()
    // }
  },
};
</script>

<style scoped lang="scss">
@import "themePath/main";
.fade-enter-active,
.fade-leave-active {
  transition: all 0.2s ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/Main.vue